import { render, staticRenderFns } from "./SlideshowGallery.vue?vue&type=template&id=cc8286da&lang=html&"
import script from "./SlideshowGallery.vue?vue&type=script&lang=js&"
export * from "./SlideshowGallery.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports